module.exports = __webpack_public_path__ + "media/logos/geskus-landing-logo-8a72624b.png";